var React = require('react');

function HoursInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 12C2.688 12 0 9.318 0 6C0 2.688 2.688 0 6 0C9.318 0 12 2.688 12 6C12 9.318 9.318 12 6 12ZM7.91398 8.22594C7.98598 8.26794 8.06398 8.29194 8.14798 8.29194C8.29798 8.29194 8.44798 8.21394 8.53198 8.06994C8.65798 7.85994 8.59198 7.58394 8.37598 7.45194L6.23998 6.17994V3.40794C6.23998 3.15594 6.03598 2.95794 5.78998 2.95794C5.54398 2.95794 5.33998 3.15594 5.33998 3.40794V6.43794C5.33998 6.59394 5.42398 6.73794 5.56198 6.82194L7.91398 8.22594Z","fill":"#656C7B"}));
}

HoursInline.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = HoursInline;

HoursInline.default = HoursInline;
